export class UserMessage {

  message: string;
  type: string = null;
  severity: 'success' | 'information' | 'warning' | 'important';
  persistToStorage = false;
  distinct = false;

  constructor(init?: Partial<UserMessage>) {
    Object.assign(this, init);
  }
}

export class UserNotification {

  constructor(
    public key: string,
    public params: any = null,
    public dismissed = false
  ) {}
}
export class UserNotificationCommand {

  constructor(
    public action: 'add' | 'clearKey' | 'clearType',
    public userNotification: UserNotification
  ) {}
}
